export const CustomErrorCodes = {
  loginFailed: {
    code: 35001,
    message:
      "nloggen mislukt. Je inloggegevens kloppen niet. Probeer het nog eens.",
  }, // login credential failed
  emailExist: {
    code: 35011,
    message:
      "E-mailadres bestaat al. Kies een ander e-mailadres of <a style='text-decoration:underline;' href='/sign-in'>log in op je account</a>.",
  }, // email already exists
  invalidPostalCode: {
    code: 35012,
    message: "Ongeldige postcode",
  },
  400: {
    code: 35002,
    message:
      "De link die je hebt gebruikt is ongeldig. Gebruik een geldige link of neem contact op met Alicia voor hulp.",
  }, // bad request
  401: {
    code: 35003,
    message:
      "De link die je hebt gebruikt is ongeldig. Gebruik een geldige link of neem contact op met Alicia voor hulp.",
  }, // unauthorized
  403: {
    code: 35004,
    message:
      "De link die je hebt gebruikt is ongeldig. Gebruik een geldige link of neem contact op met Alicia voor hulp.",
  }, // forbidden
  404: {
    code: 35005,
    message: "Oeps! We kunnen niet vinden waar je naar zoekt.",
  }, // not found
  500: {
    code: 35007,
    message:
      "De link die je hebt gebruikt is ongeldig. Gebruik een geldige link of neem contact op met Alicia voor hulp.",
  },
  // internal server error
  501: { code: 35008, message: "De functionaliteit wordt niet ondersteund." }, // Not Implemented
  502: { code: 35009, message: "Er is een fout opgetreden bij de gateway." }, // Bad Gateway
  503: { code: 35010, message: "De service is tijdelijk niet beschikbaar." }, // Service Unavailable
  504: {
    code: 35012,
    message: "De gateway heeft geen tijdige reactie ontvangen.",
  }, // Gateway Timeout
  505: { code: 35006, message: "Sorry, we kunnen je verzoek niet verwerken." }, // not supported
  unknown: {
    code: 35010,
    message:
      "De link die je hebt gebruikt is ongeldig. Gebruik een geldige link of neem contact op met Alicia voor hulp.",
  },
};
